export const contentWidth = 1000;
export const contentBreakPoint = contentWidth + 50;
